import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { FinanceComparisonCalculations } from "../../types/Calculation";

export const getQuoteFinanceComparisonCalculations = (quoteId: string) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["quote-finance-comparison-calculations", quoteId],
    queryFn: (): Promise<FinanceComparisonCalculations> => {
      return fetchWithAuth<FinanceComparisonCalculations>(
        "getQuoteFinanceComparisonCalculations",
        quoteId
      );
    },
  });
};
